/* eslint-disable react/no-multi-comp */
import React, { useMemo } from 'react';
import { useTranslation } from 'react-i18next';

import connect from '@app/utils/connect';

import { Alert } from '@app/ui';
import { useInsightsContext } from './InsightsContext';
import './insights.scss';

type InsightsProps = {
    filters: any;
};

const InsightsAlerts = ({ filters }: InsightsProps) => {
    const { t } = useTranslation('measurement');
    const { groupBy, showBroadcastData, showInVenueData } =
        useInsightsContext();

    const groupByAlert = useMemo(() => {
        // Only evaluate if groupBy is populated and valid
        if (!groupBy || Object.keys(groupBy).length === 0) {
            return null;
        }

        if (groupBy.socialAccountGroup) {
            return t('dataExplorer.alerts.socialAccountGroup');
        }
        if (groupBy.mediaUploadName) {
            return t('dataExplorer.alerts.broadcastName');
        }
        if (groupBy.country || filters?.countries?.selected?.length > 0) {
            return t('dataExplorer.alerts.broadcastCountry');
        }
        if (groupBy.gameName) {
            if (showBroadcastData && showInVenueData) {
                return t('dataExplorer.alerts.eventBroadcastAndInVenue');
            } else if (showBroadcastData) {
                return t('dataExplorer.alerts.eventBroadcast');
            } else if (showInVenueData) {
                return t('dataExplorer.alerts.eventInVenue');
            }
        }

        return null;
    }, [groupBy, filters?.countries, t]);

    if (!groupByAlert) {
        return null;
    }

    return (
        <Alert
            className="insights-alerts-banner"
            message={groupByAlert}
            type="warning"
            style={{
                marginTop: 24,
            }}
            showIcon
            closable
        />
    );
};

export default connect(['filters'])(InsightsAlerts);
